import $ from "jquery";

import "./js/flickity";
import "./js/navigation";

$(".more--link").mouseenter(function() {
  $(this)
    .children(".more--underline")
    .addClass("hover--down");
});

$(".more--link").mouseleave(function() {
  const underline = $(this).children(".more--underline");

  underline.removeClass("hover--down");
  underline.addClass("hover--up");
  setTimeout(function() {
    underline.removeClass("hover--up");
  }, 300);
});



// WEBPACK FOOTER //
// ./src/app.js